module.exports = __webpack_public_path__ + "static/img/uGreen.d9fab49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/uGreen.png
// module id = RoNs
// module chunks = 9